import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import {
  BTN_FACTORY_V3_FORM,
  BTN_FACTORY_MAX_PROGRAMS,
} from '../../clientConstants';
import ProgramFieldV3 from './ProgramFieldV3';
import { checkKeyPressed } from '../../../utility/accessibilityUtils';
import { Link, AddIcon } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';

const AddRemoveProgramsV3 = ({ programNames, addProgram }) => {
  const showUpArrow = (index) => {
    if (programNames.length === 1) {
      return false;
    }
    if (index === 0) {
      return false;
    }
    return true;
  };

  const showDownArrow = (index) => {
    if (programNames.length === 1) {
      return false;
    }
    if (index === programNames.length - 1) {
      return false;
    }
    return true;
  };

  const handleAddProgramClick = (e) => {
    checkKeyPressed(e, () => {
      addProgram();
    });
  };

  return (
    <div>
      {programNames.map((_, index) => {
        return (
          <ProgramFieldV3
            position={index}
            key={index}
            showUpArrow={showUpArrow(index)}
            showDownArrow={showDownArrow(index)}
            showDelete={programNames.length > 1}
          />
        );
      })}
      {programNames.length < BTN_FACTORY_MAX_PROGRAMS && (
        <Link
          id="addProgram"
          tabIndex="0"
          onClick={addProgram}
          onKeyDown={handleAddProgramClick}
          leftIcon={<AddIcon size="sm" />}
        >
          <Message id="buttonsV3.programs.addButton" />
        </Link>
      )}
    </div>
  );
};

AddRemoveProgramsV3.propTypes = {
  addProgram: PropTypes.func,
  programNames: PropTypes.array,
};

const mapStateToProps = (state) => {
  const formValues = getFormValues(BTN_FACTORY_V3_FORM)(state) || {};

  return {
    programNames: formValues.programNames,
  };
};

export default connect(mapStateToProps)(AddRemoveProgramsV3);
